<template>
  <div>
    <span style="text-transform: uppercase; font-weight: bold"
      >Quadro {{ numeroQuadro }} - Comparação de valores com modelo anterior em
      todos os cenários de desempenho municipal com base no cofinanciamento
      federal da APS.
    </span>
    <div class="container-table">
      <table>
        <thead>
          <tr>
            <th>RECEBIA</th>
            <th>DESEMPENHO</th>
            <th>PASSA A RECEBER</th>
            <th>AUMENTOU</th>
            <th>AUMENTOU (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in data"
            :key="index"
            :style="{ color: item.aumentouPercentual < 0 ? 'red' : 'green' }"
          >
            <td class="text-right">
              R$
              {{
                item.recebia.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
            <td>{{ item.desempenho }}</td>
            <td class="text-right">
              R$
              {{
                item.passaAreceber.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
            <td class="text-right">
              R$
              {{
                item.aumentou.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
            <td class="text-right">{{ item.aumentouPercentual }}%</td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numeroQuadro: {
      type: String,
      default: '9',
    },
    data: {
      type: Array,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  computed: {
    // recebia() {
    //   let value = 0
    //   for (const key in this.$props.previneBrasil) {
    //     const element = this.$props.previneBrasil[key]
    //     value += element
    //   }
    //   return value
    // },
    // passouAreceber() {
    //   const value =
    //     this.$props.fixo.valorImplantacao +
    //     this.$props.fixo.valorCusteio +
    //     this.$props.vinculoAcompanhamento +
    //     this.$props.qualidade +
    //     this.$props.perCapita
    //   return value
    // },
    // aumentou() {
    //   return this.passouAreceber - this.recebia
    // },
    // aumentouEmPorcentagem() {
    //   const valorDoAumento = this.aumentou
    //   const result = (valorDoAumento / this.recebia) * 100
    //   return result.toFixed(2)
    // },
  },
}
</script>
<style lang="scss" scoped>
.container-table {
  @media print {
    margin-bottom: 15px;
  }
  @media screen and (max-width: 1024px) {
    overflow: scroll;
  }
  span {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
  table {
    width: 100%;
    border: 1px solid;
    border-collapse: collapse;

    th {
      border: 1px solid black;
      text-align: center;
    }
    td {
      border: 1px solid black;
      padding: 10px;
    }
  }
}
</style>

<style lang="scss" scoped></style>
